var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPen = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E9454BFA-7F6D-49EF-8324-0A7BAD3B700B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,17.0857864 L18.5857864,8 L15.5,4.91421356 L6.41421356,14 L9.5,17.0857864 Z M7.59331966,18.0075332 L5.49246677,15.9066803 C5.25506409,16.7784843 5.08545005,17.4951947 4.98386991,18.0538854 C4.94614371,18.2613795 4.91846735,18.443857 4.90046117,18.5995388 C5.056143,18.5815326 5.23862047,18.5538563 5.44611456,18.5161301 C6.00480531,18.41455 6.72151571,18.2449359 7.59331966,18.0075332 Z M10.0288327,19.3853808 L9.78734789,19.4578263 C5.77410895,20.661798 4.05935741,20.973571 3.29289322,20.2071068 C2.52642903,19.4406426 2.83820203,17.7258911 4.04217371,13.7126521 L4.11461917,13.4711673 L15.5,2.08578644 L21.4142136,8 L10.0288327,19.3853808 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile-A",
    transform: "translate(-951.000000, -219.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-Info",
    transform: "translate(0.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_pen",
    transform: "translate(949.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FF5000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_pen.3b083f795209f7168dd00afb7364c1ce.svg";